"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _md = _interopRequireDefault(require("crypto-js/md5"));

var _portrait = require("./portrait.style");

var _portrait2 = require("./portrait.config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

let PortraitGravatar = /*#__PURE__*/function (_React$Component) {
  _inherits(PortraitGravatar, _React$Component);

  var _super = _createSuper(PortraitGravatar);

  function PortraitGravatar() {
    _classCallCheck(this, PortraitGravatar);

    return _super.apply(this, arguments);
  }

  _createClass(PortraitGravatar, [{
    key: "gravatarSrc",
    value:
    /** Generates the Gravatar URL for the specified email address and dimensions. */
    function gravatarSrc() {
      const {
        gravatarEmail,
        size
      } = this.props;
      const {
        dimensions
      } = _portrait2.PORTRAIT_SIZE_PARAMS[size];
      const base = "https://www.gravatar.com/avatar/";
      const hash = (0, _md.default)(gravatarEmail.toLowerCase());
      const fallbackOption = "404"; // "Return an HTTP 404 File Not Found response"

      /** @see https://en.gravatar.com/site/implement/images/#default-image */

      return `${base}${hash}?s=${dimensions}&d=${fallbackOption}`;
    }
    /** Renders the component. */

  }, {
    key: "render",
    value: function render() {
      const {
        alt,
        size,
        shape,
        errorCallback,
        ...otherProps
      } = this.props;
      return /*#__PURE__*/_react.default.createElement(_portrait.StyledPortraitGravatar, _extends({
        src: this.gravatarSrc(),
        alt: alt,
        size: size,
        shape: shape,
        onError: errorCallback,
        "data-element": "user-image"
      }, otherProps));
    }
  }]);

  return PortraitGravatar;
}(_react.default.Component);

PortraitGravatar.propTypes = {
  /** The theme to use. */
  theme: _propTypes.default.object,

  /** The user's email address for the Gravatar. */
  gravatarEmail: _propTypes.default.string.isRequired,

  /** The size of the Gravatar. */
  size: _propTypes.default.oneOf(["XS", "S", "M", "ML", "L", "XL", "XXL"]).isRequired,

  /** The shape of the Gravatar. */
  shape: _propTypes.default.oneOf(["circle", "square"]),

  /** The `alt` HTML string. */
  alt: _propTypes.default.string,

  /** A callback to execute if the Gravatar image fails to load. */
  errorCallback: _propTypes.default.func
};
PortraitGravatar.defaultProps = {
  shape: "square"
};
var _default = PortraitGravatar;
exports.default = _default;